import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';

import { Dialog, themes } from 'libs/ui';
import { required, DateTime } from 'libs/form';
import { Content } from './date-set-form.styled';

const DateSetFormForm = (props) => {
  const { handleSubmit, working, invalid } = props;
  const { t } = useTranslation();
  const requiredT = useCallback(required(t), [t]);

  /**
   * make action
   * @param {*} event
   */
  const submit = (values) => {
    return props.action(values);
  };

  return (
    <Dialog
      id="dialog-date-set-form"
      title={'Изменить дату действия у выбранных записей'}
      buttons={[
        { title: t('buttons.Отменить'), onClick: props.close },
        { title: t('buttons.Заменить'), onClick: handleSubmit(submit), theme: themes.blue, disabled: working | invalid, working },
      ]}
    >
      <Content>
        <form onSubmit={handleSubmit(submit)}>
          <DateTime type="dateTime" label={t('form.Дата действия по')} placeholder={t('form.Дата действия по')} name="end_at" validate={requiredT} className="hor" />
        </form>
      </Content>
    </Dialog>
  );
};

export const DateSetForm = reduxForm({
  form: 'soDateSet',
  destroyOnUnmount: true,
})(DateSetFormForm);
